export default __webpack_public_path__ + "static/media/Aaron.1583af9c.jpeg";